(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/fractiongames/assets/javascript/react/pages/games-page.js') >= 0) return;  svs.modules.push('/modules/fractiongames/assets/javascript/react/pages/games-page.js');
"use strict";


const {
  useEffect
} = React;
const {
  useParams
} = ReactRouterDOM;
const {
  useDispatch
} = ReactRedux;
const {
  Games
} = svs.numbergames.fractiongames.components;
const {
  actions
} = svs.numbergames.fractiongames.redux;
const GamesPage = () => {
  const dispatch = useDispatch();
  const {
    productParam: productFilter
  } = useParams();
  useEffect(() => {
    dispatch(actions.socketSubscribe());
    return () => {
      dispatch(actions.socketUnsubscribe());
    };
  }, [dispatch]);
  return React.createElement(Games, {
    productFilter: productFilter
  });
};
svs.fractiongames.pages.GamesPage = GamesPage;

 })(window);